import React from "react";
import { uploadFileToS3 } from "../../../../helpers/s3";

const FileUploader = ({ onTypeChange, fileInputRef, language, code }) => {
	const handleFileChange = async event => {
		const file = event.target.files[0];

		if (!file) return;

		const localUrl = URL.createObjectURL(file);

		try {
			const uploadResult = await uploadFileToS3(file, code, "attachment", language);
			if (uploadResult) {
				const { fileObject } = uploadResult;
				onTypeChange("document", { ...fileObject });
			}
		} catch (error) {
		} finally {
			URL.revokeObjectURL(localUrl);
		}
	};

	return (
		<input
			type="file"
			ref={fileInputRef}
			style={{ display: "none" }}
			onChange={handleFileChange}
			multiple={false}
		/>
	);
};

export default FileUploader;
